import { axiosIdentityInstance } from "config";
import { RoomStatus } from "enums";
import { useInfiniteQuery } from "react-query";
import { PaginationPayload, PaginationResponse } from "types";
import { BedDto } from ".";

type UseRoomsProps = PaginationPayload & {
  search?: string;
};

type RoomDto = {
  id: string;
  name: string;
  status: RoomStatus;
  isMaintenance: boolean;
  beds: BedDto[];
};

type UseRoomsResponse = PaginationResponse<RoomDto>;

function useRooms(props: UseRoomsProps) {
  const { size = 10, page = 1, search } = props;

  return useInfiniteQuery(
    ["rooms", { search }],
    ({ pageParam = page }) =>
      axiosIdentityInstance.get<UseRoomsResponse>("v1/room", {
        params: { pageSize: size, page: pageParam, search },
      }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.data.currentPage < lastPage.data.totalPages) {
          return lastPage.data.currentPage + 1;
        }
        return undefined;
      },
      getPreviousPageParam: (firstPage) => {
        if (firstPage.data.currentPage > 1) {
          return firstPage.data.currentPage - 1;
        }
        return undefined;
      },
    }
  );
}

export type { UseRoomsResponse, RoomDto };
export { useRooms };
